import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
import { toast } from 'react-toastify'; 

const response = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function gettemplate(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const params = new URLSearchParams(values).toString();
      const url = `${config.host}/cdr-panel/email-template/get-template?${params}`;
      console.log(url,"url")
      const res = await fetch(url, obj);
      return handleResponse(res);
    } catch (err) {
      return handleError(err);
    }
  }

  async function sendAutoEmail(data) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      };
      const url = `${config.host}/cdr-panel/email-template/send-auto-email`;
      const res = await fetch(url, obj);
      const json = await res.json();
      return json;
    } catch (err) {
      return handleError(err);
    }
  }
  async function getLoyaltyID(data) {
    try {
      const obj = {
        method: "POST", 
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data), 
      };
  
      const url = `${config.host}/cdr-panel/email-template/get-loyaltyID`;
      const res = await fetch(url, obj);
      const json = await res.json();
  
      return json;
    } catch (err) {
      console.error("getLoyaltyID error:", err);
      return { valid: false, message: "Network error" };
    }
  }
  async function getBilltoID(data) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data), 
      };
  
      const url = `${config.host}/cdr-panel/email-template/get-billtoID`;
      const res = await fetch(url, obj);
      const json = await res.json();
  
      return json;
    } catch (err) {
      console.error("getbilltoID error:", err);
      return { valid: false, message: "Network error" };
    }
  }
  async function updateSubject(data) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const url = `${config.host}/cdr-panel/email-template/update-subject`
      console.log(url, "url");
  
      const res = await fetch(url, obj);
      const json = await res.json();
      return json;
  
    } catch (error) {
      console.error("updateSubject API error:", error);
      return { valid: false, message: "Network error" };
    }
  }
  
  // async function updateContent(data) {
  //   try {
  //     const obj = {
  //       method: "POST",
  //       credentials: "include",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(data),
  //     };
  
  //     // Remove /cdr-panel from URL
  //     const url = `${config.host}/cdr-panel/email-template/update-content`
  //     console.log(url, "url");
  
  //     const res = await fetch(url, obj);
  //     const json = await res.json();
  //     return json;
  
  //   } catch (error) {
  //     console.error("updateSubject API error:", error);
  //     return { valid: false, message: "Network error" };
  //   }
  // }
  
  async function handleSendEmail(data) {
    
    console.log(data, "dattaa");
    console.log(data.loyaltyId, "loyaltyy");
    // Validate Loyalty ID if provided
    if (data.loyaltyId) {
      console.log(data, "dattaa");
    console.log(data.loyaltyId, "loyaltyy");
      const loyaltyCheck = await getLoyaltyID({ loyaltyId: data.loyaltyId, email: '' });
      console.log(loyaltyCheck, "loyalty check");
      if (!loyaltyCheck || !loyaltyCheck.valid) {
        toast.error('Please enter a valid Loyalty ID.', {
          position: "top-right",
          autoClose: 5000,
        });
        return { success: false, message: 'Invalid Loyalty ID' };
      }
    }
  
    // Validate Billto ID if provided
    if (data.billtoID) {
      console.log(data, "dattaa");
    console.log(data.loyaltyId, "loyaltyy");
      const billtoCheck = await getBilltoID({ billtoID: data.billtoID, email: '' });
      console.log(billtoCheck, "billto check");
      if (!billtoCheck || !billtoCheck.valid) {
        toast.error('Please enter a valid Billto ID.', {
          position: "top-right",
          autoClose: 5000,
        });
        return { success: false, message: 'Invalid Billto ID' };
      }
    }
  
    // Send email
    const emailRes = await sendAutoEmail(data);
  
    if (!emailRes?.success) {
      if (emailRes.errorCode === 'invalid_email') {
        toast.error('Email failed: Invalid email address');
      } else if (emailRes.errorCode === 'template_inactive') {
        toast.error('Template is inactive');
      } else {
        toast.error('Failed to send email: ' + (emailRes?.message || 'Unknown error'));
      }
  
      return emailRes;
    }
  
    toast.success('Email sent successfully!');
    return emailRes;
  
  }
  
  return {
    gettemplate,
    sendAutoEmail,
    getLoyaltyID,
    handleSendEmail,
    getBilltoID, 
    updateSubject
    //updateContent
  };
};

export default response;
